import qs from 'qs'
import axios from 'axios'
// let escape = window.escape

// axios.defaults.baseURL = window.CONTEXT || '/exchange-openplatform'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
let __iflytekToken__ = ''
axios.interceptors.request.use((request) => {
  if (request.data && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    request.data = qs.stringify(request.data, { allowDots: true })
  }
  if (request.method === 'get') {
    if (!request.params) {
      request.params = {}
    }
    request.params.t = new Date().getTime()
  } else if (request.method === 'post') {
    // warning: 注意，目前只对POST做CRSF防范，不考虑PUT,DELETE
    request.headers['ecssafetytoken'] = __iflytekToken__
  }
  return request
})

axios.interceptors.response.use(function (response) {
  // Do something with response data
  if (response.headers['ecssafetytoken']) {
    __iflytekToken__ = response.headers['ecssafetytoken']
  }
  return response
}, function (error) {
  // // Do something with response error
  // if (error.response.headers['sessionstatus'] === 'no') {
  //   // router.push('/login')
  //   window.location.href='/desktop/login'
  // } else if (error.response.headers['authoritystatus'] === 'no') {
  //   // 无权限
  //   alert('无权限。。。。todo。。。')
  // }
  return Promise.reject(error)
})

export function axiosFactory ({ method, url, params, data, ignore }) {
  return new Promise((resolve, reject) => {
    axios({
      method,
      url,
      params, // 不能再这里直接设置headers，会覆盖Authorization
      data
    }).then(({ data }) => {
      if (ignore) {
        resolve(data)
      } else {
        data.success ? resolve(data.data) : reject(data)
      }
    }).catch((err) => {
      let res = (err && err.response) || err
      reject(res)
    })
  })
}

export function axiosPostFactory ({url, data, cType}) {
  let contentType = ''
  if (cType !== undefined) {
    contentType = cType
  } else {
    contentType = 'application/x-www-form-urlencoded'
  }
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data,
      headers: {'Content-Type': contentType} // 不同的项目可能这里不同，具体请百度Content-type相关
    }).then(({ data }) => {
      data.success ? resolve(data) : reject(data)
    }).catch((error) => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/pages/exchangeDataManage/services/axios-factory.js